export default "__VITE_ASSET__DTxMVQxi__"